import script from "./ImgForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImgForm.vue?vue&type=script&lang=ts&setup=true"

import "./ImgForm.vue?vue&type=style&index=0&id=4cc7340e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/.pnpm/vue-loader@17.3.1_@vue+comp_8f2c4c49f6fda9a4fff749d98711c87c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc7340e"]])

export default __exports__